import axios from "axios";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {
    IAccrualSnapshotScopeOptions,
    IAccrualSnapshotScopeResults,
    ISnapshotService
} from "../PA.Snapshot.Core/PA.Snapshot.IF.Aspects";


export interface ISnapshotServiceRequest {
    requestType:        string,
    wbSnapshotParamId?: number,
    options?:           any
}

export interface ISnapshotServiceResponse {
    request: ISnapshotServiceRequest,
    bSuccess: boolean,
    sErrors: string[],
    sWarnings: string[],
    results: any
}

export class SnapshotService
    implements ISnapshotService
{
    constructor() {}

    async getAccrualScope(wbSnapshotParamId: number, options: IAccrualSnapshotScopeOptions): Promise<IAccrualSnapshotScopeResults> {
        return await SnapshotService.makeRequest({
            requestType: "getAccrualScope",
            wbSnapshotParamId: wbSnapshotParamId,
            options: options
        })

    }

    async getAccrualScopeProductLevels(wbSnapshotParamId: number, options: IAccrualSnapshotScopeOptions): Promise<number[]> {
        return await SnapshotService.makeRequest({
            requestType: "getAccrualScopeProductLevels",
            wbSnapshotParamId: wbSnapshotParamId,
            options: options
        })

    }


    //
    private static async makeRequest(snapshotRequest: ISnapshotServiceRequest)
        : Promise<any>
    {

        try {

            let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base, "/"));
            if (sEndPoint.endsWith('/'))
                sEndPoint += 'snapshot';
            else
                sEndPoint += '/snapshot';

            let resp = await axios.post(sEndPoint, {data: {request: snapshotRequest}})
            let responseData: ISnapshotServiceResponse = resp.data;
            if ('request' in responseData) {
                if (!responseData.bSuccess) {
                    throw new Error("Snapshot Service Response: " + (responseData.sErrors || ['Unknown']).toString())
                } else {
                    return responseData.results
                }
            }

            throw new Error('Unable to parse Snapshot Service Web Response: ' + responseData);

        } catch (err: any) {
            throw new Error('Unable to obtain Snapshot Service Results from Server. ' + err);
        }
    }

}
